import React, { useEffect, useState } from "react";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import i18n from "i18next";
import { baseUrl } from "../../../helpers/constants";
import useWindowSize from "../../../helpers/useWindowSize";
import { IEmailTemplate } from "../../../Models/IEmailTemplate";
// Fluent UI Imports
import {
  Dropdown,
  Field,
  Input,
  Textarea,
  Option,
} from "@fluentui/react-components";

interface IAddEditEmailTemplateProps {
  newTemplate(item: IEmailTemplate): void;
  template: IEmailTemplate;
  selectedTab: string;
}

function AddEditEmailTemplate(props: IAddEditEmailTemplateProps) {
  const [selectedTabValue, setSelectedTabValue] = useState<string>("HTML");
  const [template, setTemplate] = useState<IEmailTemplate>(props.template);
  const handleSelectedTemplateChange = (name: string, val: string) => {
    setTemplate((prevState: any) => ({
      ...prevState,
      [name]: val,
    }));
  };

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const [templateBody, setTemplateBody] = useState("");

  const onCheckIfCanSaveTemplate = (): boolean => {
    if (template) {
      if (!template.name) return false;
      if (!template.sprache) return false;
      if (!template.subject) return false;
      if (!template.content) return false;
    } else {
      return false;
    }

    return true;
  };

  const pivotItemStyles = {
    height: "calc(100vh - 134px)",
    overflow: "auto",
  };
  const spracheOptions = ["en", "de"];
  const getTemplateBody = (lang: string) => {
    fetchWrapper
      .get(baseUrl + "/api/emailtemplate/GetTemplateBody?lang=" + lang)
      .then((result: any) => {
        setTemplateBody(result.body);
      });
  };
  useEffect(() => {
    props.newTemplate(template);
  }, [template]);
  useEffect(() => {
    if (template && template.sprache) {
      getTemplateBody(template.sprache);
    }
  }, [template.sprache]);
  useEffect(() => {
    setSelectedTabValue(props.selectedTab);
  }, [props.selectedTab]);
  const windowSize = useWindowSize();

  return (
    <div>
      {selectedTabValue == "vorschau" && (
        <div
          dangerouslySetInnerHTML={{
            __html: template
              ? templateBody.replace("{content}", template.content)
              : "<div></div>",
          }}
        />
      )}
      {selectedTabValue == "HTML" && (
        <>
          <Field label="Name">
            <Input
              onChange={(ev, val) => {
                handleSelectedTemplateChange(
                  "name",
                  val.value ? val.value : "",
                );
                setErrorMessage("");
                setSuccessMessage("");
              }}
              value={template ? template.name : ""}
            />
          </Field>
          <Field label="Sprache">
            <Dropdown
              defaultValue={template.sprache}
              defaultSelectedOptions={[template.sprache]}
              onOptionSelect={(ev, data) => {
                handleSelectedTemplateChange(
                  "sprache",
                  data.optionValue ? data.optionValue : "en",
                );
              }}
            >
              {spracheOptions.map((option: string) => {
                return (
                  <Option value={option} disabled={option == template.sprache}>
                    {option}
                  </Option>
                );
              })}
            </Dropdown>
          </Field>
          <Field label="Titel">
            <Input
              onChange={(ev, val) => {
                handleSelectedTemplateChange(
                  "subject",
                  val.value ? val.value : "",
                );
                setErrorMessage("");
                setSuccessMessage("");
              }}
              value={template ? template.subject : ""}
            />
          </Field>
          <Field label="Inhalt">
            <Textarea
              rows={20}
              onChange={(ev, val) => {
                handleSelectedTemplateChange(
                  "content",
                  val.value ? val.value : "",
                );
                setErrorMessage("");
                setSuccessMessage("");
              }}
              value={template ? template.content : ""}
            />
          </Field>
        </>
      )}
    </div>
  );
}

export default AddEditEmailTemplate;
